// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-button{display:inline-block}.lc-am-button.is-hidden{opacity:0;cursor:default}.lc-am-button.is-disabled{cursor:not-allowed}.lc-am-button.is-disabled button{pointer-events:none}.lc-am-button span .lc-am-icon{margin-bottom:4px}.lc-am-button span .inner-icon+span,.lc-am-button span>span+.right,.lc-am-button span svg+span{margin-left:8px}.lc-am-button+.lc-am-button{margin-left:12px}.lc-am-button button{width:inherit;height:inherit}", ""]);
// Exports
module.exports = exports;
